import React, { useEffect, useState } from 'react'
import { IntlProvider } from 'react-intl'
import { Switch, Route, Redirect, useLocation } from 'react-router-dom'
import shortid from 'shortid'

import { getRouterConfig } from 'config/router'
import { init } from 'config/config'

import ShoppingCart from '../components/organisms/ShoppingCart'

import './style.scss'

function App() {
  const location = useLocation()

  const [initInfo, setInitInfo] = useState()
  const initPage = async () => {
    const { locale, terms, countryName, baseUrl, hasFundComparison, fundComparisonCart } = await init(location)
    const routerConfig = await getRouterConfig(countryName, baseUrl)
    setInitInfo({
      locale,
      routerConfig,
      terms,
      hasFundComparison,
      fundComparisonCart
    })
  }

  const onIntlError = () => {}

  useEffect(async () => {
    await initPage()
  }, [])

  return (
    <React.Fragment>
      {initInfo && (
        <IntlProvider messages={initInfo.terms} locale={initInfo.locale} onError={onIntlError}>
          <div className="gdpp-app-container">
            <header className="gdpp-app-header">
              {/* {env && <p>Env - {env}</p>} */}
              {/* <FormattedMessage id="myMessage" defaultMessage="Today is {ts, date, ::yyyyMMdd}" values={{ ts: Date.now() }} /> */}
            </header>
            <Switch>
              {initInfo.routerConfig.map((route) => {
                if (route.isRedirect) {
                  return (
                    <Redirect
                      key={`redirect_${shortid.generate()}`}
                      {...(route.exact ? { exact: !!route.exact } : {})}
                      from={route.from}
                      to={route.to}
                    />
                  )
                }

                return (
                  <Route
                    key={`route_${shortid.generate()}`}
                    {...(route.url ? { path: route.url } : {})}
                    {...(route.exact ? { exact: !!route.exact } : {})}
                    render={(props) => <route.component alias={route.alias} {...props} />}
                  />
                )
              })}
            </Switch>
            {initInfo.hasFundComparison && <ShoppingCart storageType="session" storageKey={initInfo.fundComparisonCart} />}
            <footer>
              <span className="version">version:[RC_25.6.0]</span>
            </footer>
          </div>
        </IntlProvider>
      )}
    </React.Fragment>
  )
}

export default App
